<template>
    <div class="choose-box">
        <!-- 5.0之前 -->
        <div class="old-version" v-if="version === '4'">
            <div class="title-bar">
                <p>{{ title }}</p>
            </div>
            <div ref="chooseContent" class="choose-content">
                <div v-if="!setMembers.length && !playRandom" class="hint-box">
                    <div class="hint-content">
                        <img :src="chooseIcon" alt="" />
                        <p>还没有幸运儿被选中</p>
                    </div>
                </div>

                <div v-else class="choose-member">
                    <p class="choose-member-title">{{ playRandom ? '摇一摇，摇到谁就选谁' : '请开始你的表演，并等待老师评分'}}</p>
                    <div class="choose-member-result">
                        <div v-for="(item,index) in setMembers" :id="'result-box-' + item.id" :key="index.id" class="choose-member-result-user">
                            <div class="user-avatar">
                                <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="">
                                <div v-show="item.score !== undefined" :class=" item.score < 0 ? 'negative' : '' " class="score">{{ item.score }}</div>
                            </div>
                            <p class="choose-name">{{ item.fullName }}</p>
                        </div>

                        <!-- 摇一摇动画 -->
                        <div class="random-shaking-box" v-if="playRandom">
                            <div v-if="otherMembers[r]" class="user-avatar">
                                <img :src="otherMembers[r].avatarUrl == null ? avatarUrl : otherMembers[r].avatarUrl" />
                            </div>
                            <p class="random-shaking-name">{{ otherMembers[r] ? otherMembers[r].fullName : ''}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- 5.0之后 -->
        <div class="new-version" v-else-if="version === '5'">
            <div class="title-bar">
                <p>{{ title }}</p>
            </div>
            <div ref="chooseContentForNew" class="choose-content">
                
                <!-- 随机选人 -->
                <div v-if="hintData == 'random'" class="member-box">
                    <div v-if="!setMembers.length && !playRandom" class="shaking-box">
                        <div class="hint-content">
                            <img :src="shakeIcon" alt="" />
                            <p>{{ hintContent }}</p>
                        </div>
                    </div>

                    <div v-else class="choose-member">
                        <p class="choose-member-title">{{ hintContent }}</p>

                        <!-- 成员列表 -->
                        <div class="choose-member-result">
                            <div v-for="(item,index) in setMembers" :id="'result-box-' + item.id" :key="index.id" class="choose-member-result-user">
                                <div class="user-avatar">
                                    <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="">
                                    <div v-show="item.score !== undefined" :class=" item.score < 0 ? 'negative' : '' " class="score">{{ item.score }}</div>
                                </div>
                                <p class="choose-name">{{ item.fullName }}</p>
                            </div>

                            <!-- 摇一摇动画 -->
                            <div class="random-shaking-box" v-if="playRandom">
                                <div v-if="otherMembers[r]" class="user-avatar">
                                    <img :src="otherMembers[r].avatarUrl == null ? avatarUrl : otherMembers[r].avatarUrl" />
                                </div>
                                <p class="random-shaking-name">{{ otherMembers[r] ? otherMembers[r].fullName : ''}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 手动选人 -->
                <div v-if="hintData == 'manual'" class="member-box">
                    <div v-if="!setMembers.length" class="hint-box">
                        <div class="hint-content">
                            <img :src="chooseIcon" alt="" />
                            <p>{{ hintContent }}</p>
                        </div>
                    </div>

                    <div v-else class="choose-member">
                        <p class="choose-member-title">请开始你的表演，并等待老师评分</p>
                        <div class="choose-member-result">
                            <div v-for="(item,index) in setMembers" :id="'result-box-' + item.id" :key="index.id" class="choose-member-result-user">
                                <div class="user-avatar">
                                    <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="">
                                    <div v-show="item.score !== undefined" :class=" item.score < 0 ? 'negative' : '' " class="score">{{ item.score }}</div>
                                </div>
                                <p class="choose-name">{{ item.fullName }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import chooseIcon from '@/assets/image/choose_icon.png';
import shakeIcon from '@/assets/image/shake_icon.png';
import avatarUrl from '@/assets/image/user-avatarUrl.jpg';
// import tool from '@/assets/scripts/tool.js';
import Wings from '../assets/scripts/wings.js';
import { clearInterval, setInterval, setTimeout } from 'timers';

export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        },
        version: {
            type: String,
            default: '4'
        }
    },
    
    data: function() {
        return {
            title: '选人',
            chooseIcon: chooseIcon,
            shakeIcon: shakeIcon,
            avatarUrl: avatarUrl,
            hintContent: '还没有幸运儿被选中',
            shakeTitle: '摇一摇，摇到谁就选谁',
            supportedEventNames: [
                'crp.chooseMembers.start',
                'crp.chooseMembers.setMembers',
                'crp.chooseMembers.enterRandom',
                'crp.chooseMembers.playRandom',
                'crp.chooseMembers.exitRandom',
                'crp.chooseMembers.setScore',
                'crp.chooseMembers.end',
                // 5.0新增指令
                'crp.chooseManual.enter',
                'crp.chooseManual.setMembers',
                'crp.chooseManual.setScore',
                'crp.chooseManual.end',
                'crp.chooseRandom.enter',
                'crp.chooseRandom.play',
                'crp.chooseRandom.setMembers',
                'crp.chooseRandom.setScore',
                'crp.chooseRandom.end',
                'common.moveJoystick'],
            r: 0,
            hintData: 'start',
            hidRandom: false,
            isRandom: false,
            playRandom: false,
            clazzCourseId: null,
            wingsAll: null,
            members: [],
            setMembers: [],
            randomTimer: null,
            otherMembers: [],
        };
    },

    computed:{
    },

    watch: {
        currentShow: function (newVal, oldVal) {
            // the stage is hiding me
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.members = [];
                this.setMembers = [];
                this.otherMembers = [];
                this.wingsAll.hideAnimation();
            }
        }
    },


    created: function() {
        this.wingsAll = new Wings();
        this.members = this.otherMembers = this.setMembers = [];
        this.playRandom = false;
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
        this.componentId = null;
        if(this.randomTimer) clearInterval(this.randomTimer);
    },
    
    methods: {
        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg) return;
            if ( ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            const msgData = msg.data;
            // console.log(msg.eventName, msg.data);
            switch (msg.eventName) {
                case 'crp.chooseMembers.start':
                    this.crpChooseMembersStart(msgData);
                    break;
                case 'crp.chooseMembers.setMembers':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpChooseMembersSetMembers(msgData);
                    break;
                case 'crp.chooseMembers.enterRandom':
                    // this.crpChooseMembersEnterRandom(msgData);
                    break;
                case 'crp.chooseMembers.playRandom':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpChooseMembersPlayRandom(msgData);
                    break;
                case 'crp.chooseMembers.exitRandom':
                    this.crpChooseMembersExitRandom(msgData);
                    break;
                case 'crp.chooseMembers.setScore':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpChooseMembersSetScore(msgData);
                    break;
                case 'common.moveJoystick':
                    console.log(this.componentId);
                    if (this.componentId) this.moveJoystick(msgData);
                    break;
                case 'crp.chooseMembers.end':
                    this.crpChooseMembersEnd();
                    break;
                    // 5.0新增指令 
                    // 进入手动选人
                case 'crp.chooseManual.enter':
                    this.crpChooseManualEnter(msgData);
                    break;
                case 'crp.chooseManual.setMembers':
                    this.crpChooseManualSetMembers(msgData);
                    break;
                case 'crp.chooseManual.setScore':
                    this.crpChooseManualSetScore(msgData);
                    break;
                case 'crp.chooseManual.end':
                    this.crpChooseManualEnd(msgData);
                    break;
                case 'crp.chooseRandom.enter':
                    this.crpChooseRandomEnter(msgData);
                    break;
                case 'crp.chooseRandom.play':
                    this.crpChooseRandomPlay(msgData);
                    break;
                case 'crp.chooseRandom.setMembers':
                    this.crpChooseRandomSetMembers(msgData);
                    break;
                case 'crp.chooseRandom.setScore':
                    this.crpChooseRandomSetScore(msgData);
                    break;  
                case 'crp.chooseRandom.end':
                    this.crpChooseRandomEnd(msgData);
                    break;
                
                default:
                    // statements_def
                    break;
            }
        },

        crpChooseMembersStart: function(msgData) {
            this.hintData = 'start';
            this.title = '选人';
            this.clazzCourseId = msgData.clazzCourseId;
            this.members = JSON.parse(JSON.stringify(msgData.members));
            this.crpChooseMembersSetMembers(msgData);
            this.crpChooseMembersSetScore(msgData);
        },

        crpChooseMembersSetMembers: function(msgData) {
            this.otherMembers = JSON.parse(JSON.stringify(this.members));
            this.setMembers = [];
            
            if (msgData.chosenMembers.length === 0) {
                if (this.hintData === 'random') return;
                this.hintData = 'start';
                return;
            };
            msgData.chosenMembers.forEach(m => {
                let index = this.members.findIndex(ele => ele.id === m.id);
                this.otherMembers[index].isSelected = true;
                this.setMembers.push(JSON.parse(JSON.stringify(this.members[index])));
            });

            if (this.isRandom) return;
            this.hintData = 'setMembers';
            msgData.chosenMembers.forEach(c => {
                let index = this.setMembers.findIndex(ele => ele.id === c.id);
                this.setMembers[index].score = c.score;
                this.$set(this.setMembers,index,this.setMembers[index]);
            });

            this.scrollToButtom();
        },

        crpChooseMembersEnterRandom: function() {
            this.hintData = 'random';
            this.playRandom = false;
            this.isRandom = true;
            this.otherMembers = this.otherMembers.filter(value => !value.isSelected);
        },

        crpChooseMembersPlayRandom: function(msgData) {
            // clearTimeout(timerOut);
            this.hintData = 'random';
            this.isRandom = true;
            this.playRandom = true;
            this.otherMembers = this.otherMembers.filter(value => !value.isSelected);

            let index = this.otherMembers.findIndex(m => msgData.memberId === m.id);
            this.otherMembers[index].isSelected = true;
            let other = this.otherMembers.filter(value => !value.isSelected);

            this.shakingAnimationForNew(() => {
                this.setMembers.push(this.otherMembers[index]);
            });

            this.scrollToButtom();
        },

        shakingAnimation: function(other,index) {
            clearTimeout(timerOut);
            clearTimeout(backShaking);
            this.playRandom = true;
            if (other.length === 0) {
                this.r = index;
                this.shakeTitle = '别摇了，就 TA 吧';
                return;
            };
            
            let timer = setInterval( () => {
                if ( this.r < other.length) {
                    this.r ++;
                    this.hidRandom = !this.hidRandom;
                } else {
                    this.r = 0;
                    this.hidRandom = !this.hidRandom;
                }
            },100);
            let backShaking;
            let timerOut = setTimeout( () => {
                clearInterval(timer);
                this.hidRandom = false;
                this.shakeTitle = '就 TA 吧';
                backShaking = setTimeout( () => {
                    this.playRandom = false;
                    this.shakeTitle = '摇一摇，摇到谁就选谁';
                    this.otherMembers = other;
                },1000);
            },2000);

        },

        crpChooseMembersExitRandom: function() {
            this.isRandom = false;
            if ( !this.setMembers.length) {
                this.hintData = 'start';
            } else {
                this.hintData = 'setMembers';
            }
        },

        crpChooseMembersSetScore: function(msgData) {
            msgData.chosenMembers.forEach(c => {
                let index = this.setMembers.findIndex(ele => ele.id === c.id);
                let sameScore = false;
                if (this.setMembers[index].score === c.score) sameScore = true;
                this.setMembers[index].score = c.score;
                this.$set(this.setMembers,index,this.setMembers[index]);

                if (sameScore) return;
                const avatar = document.querySelector('#result-box-' + this.setMembers[index].id).querySelector('.user-avatar > img');
                this.wingsAll.pushAnimation(avatar, this.setMembers[index].fullName, this.setMembers[index].score);
                
            });
        },

        // 以下为5.0新加指令方法
        /**
         * 进入手动选人
         */
        crpChooseManualEnter(msgData) {
            this.title = '手动选人';
            this.hintData = 'manual';
            this.hintContent = '还没有幸运儿被选中';
            this.clazzCourseId = msgData.clazzCourseId;
            this.members = JSON.parse(JSON.stringify(msgData.members));
            this.setMembers = [];

            this.crpChooseManualSetMembers(msgData);
            this.crpChooseManualSetScore(msgData);
        },

        /**
         * 手动选人设置选中的成员
         */
        crpChooseManualSetMembers(msgData) {
            this.setMembers = [];
            this.hintContent = '请开始你的表演，并等待老师评分';
            if (msgData.chosenMembers.length === 0) {
                this.hintContent = '还没有幸运儿被选中';
                return;
            };

            msgData.chosenMembers.forEach(m => {
                let index = this.members.findIndex(ele => ele.id === m.id);
                if (index > -1) {
                    let student = JSON.parse(JSON.stringify(this.members[index]));
                    if (m.score || m.score == 0) {
                        student.score = m.score;
                    }
                    this.setMembers.push(student);
                }
            });

            this.scrollToButtom();
        },

        crpChooseManualSetScore(msgData) {
            // 因为可能存在进入页面时就有分数，所以进来就要赋值，
            // 因为这两个方法时一起的，但实际上这个方法应该在上一个方法更新dom后执行，所以用nextTick
            this.$nextTick(() => {
                if (!this.setMembers.length) return;
                msgData.chosenMembers.forEach(c => {
                    let index = this.setMembers.findIndex(ele => ele.id === c.id);
                    let sameScore = false;
                    if (this.setMembers[index].score === c.score) sameScore = true;
                    this.setMembers[index].score = c.score;
                    this.$set(this.setMembers,index,this.setMembers[index]);
    
                    if (sameScore) return;
                    let t = document.querySelector('#result-box-' + this.setMembers[index].id);
                    const avatar = document.querySelector('#result-box-' + this.setMembers[index].id).querySelector('.user-avatar > img');
                    this.wingsAll.pushAnimation(avatar, this.setMembers[index].fullName, this.setMembers[index].score);
                });
            })
        },

        crpChooseManualEnd(msgData) {
            this.wingsAll.hideAnimation();
        },

        crpChooseRandomEnter(msgData) {
            this.title = '随机选人';
            this.hintData = 'random';
            this.hintContent = '摇一摇手机，开始选人吧';
            this.clazzCourseId = msgData.clazzCourseId;
            
            this.setMembers = [];
            this.members = JSON.parse(JSON.stringify(msgData.members));
            this.otherMembers = JSON.parse(JSON.stringify(msgData.members));

            this.crpChooseRandomSetMembers(msgData);
            this.crpChooseRandomSetScore(msgData);
        },

        crpChooseRandomPlay(msgData) {
            this.hintData = 'random';
            let index = this.otherMembers.findIndex(item => item.id === msgData.memberId);

            if(index > -1) {
                let callback = () => {
                    let choosePerson = this.otherMembers[index];
                    this.otherMembers.splice(index, 1);
                    this.setMembers.push(choosePerson);
                    this.hintContent = '请开始你的表演，并等待老师评分';
                }

                if (this.otherMembers.length == 1) {
                    callback();
                } else {
                    this.shakingAnimationForNew(callback);
                }
            }

            this.scrollToButtom();
        },

        crpChooseRandomSetMembers(msgData) {
            if (msgData.chosenMembers.length === 0) {
                this.hintContent = '摇一摇手机，开始选人吧';
                this.setMembers = [];
                this.otherMembers = JSON.parse(JSON.stringify(this.members));
                return;
            };
            this.setMembers = [];
            this.otherMembers = [];
            this.hintContent = '请开始你的表演，并等待老师评分';


            this.members.forEach(item => {
                let index = msgData.chosenMembers.findIndex(ele => ele.id === item.id);
                if (index > -1) {
                    let student = JSON.parse(JSON.stringify(item));
                    if (msgData.chosenMembers[index].score || msgData.chosenMembers[index].score == 0) {
                        student.score = msgData.chosenMembers[index].score;
                    }
                    this.$set(this.setMembers, index, student);
                } else {
                    this.otherMembers.push(JSON.parse(JSON.stringify(item)));
                }
            });

            this.scrollToButtom();
        },

        crpChooseRandomSetScore(msgData) {
            msgData.chosenMembers.forEach(c => {
                let index = this.setMembers.findIndex(ele => ele.id === c.id);
                let sameScore = false;
                if (this.setMembers[index].score === c.score) sameScore = true;
                this.setMembers[index].score = c.score;
                this.$set(this.setMembers,index,this.setMembers[index]);

                if (sameScore) return;
                let t = document.querySelector('#result-box-' + this.setMembers[index].id);
                const avatar = document.querySelector('#result-box-' + this.setMembers[index].id).querySelector('.user-avatar > img');
                this.wingsAll.pushAnimation(avatar, this.setMembers[index].fullName, this.setMembers[index].score);
            });
        },

        crpChooseRandomEnd(msgData) {
            this.wingsAll.hideAnimation();
        },

        shakingAnimationForNew(callback) {
            if (!this.otherMembers.length) {
                return;
            };
            this.playRandom = true;
            this.hintContent = '摇一摇，摇到谁就选谁';
            this.r = 0;
            let num = 0;
            this.randomTimer = setInterval( () => {
                if (num >= 2000 / 100) {
                    clearInterval(this.randomTimer);
                    this.playRandom = false;
                    if(callback && typeof(callback) === 'function') {
                        callback();
                    }
                }

                if (this.r < this.otherMembers.length - 1) {
                    this.r++;
                } else {
                    this.r = 0;
                }
                num++;
            },100);
        },

        moveJoystick: function(msgData) {
            let box = null;
            let direction = msgData.direction;
            let chooseContent = this.$refs.chooseContent;
            let chooseContentForNew = this.$refs.chooseContentForNew;

            if (this.version === '4') {
                box = chooseContent;
                this.boxOfElement(direction,box);
            } else if (this.version === '5') {
                box = chooseContentForNew;
                this.boxOfElement(direction,box);
            } else {
                return;
            }

        },

        boxOfElement: function(direction,box) {
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                box.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                box.scrollTop += 40;
            } else {
                return;
            }
        },

        crpChooseMembersEnd: function() {
            this.wingsAll.hideAnimation();
        },

        scrollToButtom() {
            this.$nextTick(() => {
                for(let key in this.$refs) {
                    if(this.$refs[key]) {
                        this.$refs[key].scrollTop = this.$refs[key].scrollHeight;
                    }
                }
            });
        },

    }
};
</script>

<style scoped>
    .old-version,
    .new-version {
        height: 100%;
    }
    .choose-box {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .title-bar {
        width: 100%;
        display: flex;
        height: 80px;
        background-color: #191919;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .title-bar p {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        width:600px;
    }

    .choose-content{
        width: 100%;
        height: calc( 100% - 80px );
        margin-top: 80px;
        box-sizing: border-box;
        display: flex;
        flex: 2;
        overflow-y: auto;
    }

    .hint-box {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }
    
    .hint-content {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #e8e8e8;
        align-items: center;
        flex-direction: column;
        margin-top: -80px;
    }

    .hint-content img {
        width: 200px;
        height: 200px;
    }

    .random-box,
    .member-box{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .shaking-box {
        display: flex;
        justify-content: center; 
        align-items: center;
        flex: 1;
    }

    .shaking {
        /* width: 100%; */
        display: flex;
        justify-content: center; 
        align-items: center;
        flex-direction: column;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
    }

    .shaking img {
        width: 280px;
        height: 280px;
        margin: 40px 0;
        border: 8px solid #ffffff;
        border-radius: 50%;
    }

    .shaking .username {
        font-size: 36px;
        color: #e8e8e8;
        overflow:hidden; 
        text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:1; 
    }

    .playingRandom {
        width: 296px;
        height: 436px;
        overflow: hidden;
        position: relative;
    }

    .hide {
        opacity: 0;
    }

    .playingRandom > div {
        transition: opacity 100ms linear;
    }

    .random-member{
        width: 457px;
        height: 100%;
        background: #323232;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .random-member-title {
        font-size: 24px;
        color: #FFFFFF;
        text-align: left;
        padding: 40px 0 20px 0;
        box-sizing: border-box;
    }

    .random-member-result {
        display: flex;
        flex-wrap: wrap;
    }

    .random-member-result > div {
        width: 118px;
        margin: 20px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .random-member-result-user > img {
        width: 80px;
        height: 80px;
        box-sizing: border-box;
        border: 4px solid #ffffff;
        border-radius: 50%;
    }

    .random-member-result-user > p {
        max-width: 108px;
        font-size: 18px;
        color: #CCCCCC;
        text-align: center;
        margin-top: 20px;
        overflow:hidden; 
        text-overflow:ellipsis;
        display:-webkit-box; 
        -webkit-box-orient:vertical;
        -webkit-line-clamp:1; 
    }

    .choose-member {
        width: 100%;
        height: 100%;
        padding-top: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        /* padding: 0 60px; */
        box-sizing: border-box;
    }

    .choose-member-result {
        display: flex;
        height: 100%;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }

    .choose-member-result > div {
        width: 240px;
        margin: 30px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .user-avatar {
        width: 200px;
        height: 200px;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }

    .user-avatar img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        border: 6px solid #ffffff;
    }

    .score {
        width: 200px;
        padding: 50px 0 20px 0;
        background-image: url("../assets/image/score.png");
        background-repeat: no-repeat;
        background-size: 200px 100px;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #ffffff;
    }

    .negative {
        background-image: url("../assets/image/negative.png");
        background-size: 200px 100px;
    }

    .choose-member-result-user p {
        max-width: 200px;
        font-size: 24px;
        color: #CCCCCC;
        text-align: center;
        margin-top: 20px;
        overflow: hidden; 
        text-overflow: ellipsis;
        display: -webkit-box; 
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; 
    }

    .choose-member-title {
        font-size: 24px;
        color: #e8e8e8;
        padding: 0px 0 30px 0;
    }

    .random-shaking-name{
        max-width: 200px;
        font-size: 24px;
        color: #CCCCCC;
        height: 36px;
        text-align: center;
        margin-top: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }
</style>
